import React from "react";
import buttonBorderBg from "assets/images/flus/button-bg.png";
import { staticBounceVariants } from "shared/components/animations";
import { motion } from "framer-motion/dist/framer-motion";

const FlusterButton = ({ text, onClick, isQuestionScreen = false }) => {
  return (
    <motion.div
      variants={staticBounceVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="flus-button-container"
      onClick={onClick}
    >
      <img
        alt="border-bg"
        src={buttonBorderBg}
        className={`border-img ${
          isQuestionScreen ? "vote-button-container" : ""
        }`}
      />
      <h2>{text}</h2>
    </motion.div>
  );
};

export default FlusterButton;
